const BASE_URL: unknown = import.meta.env["VITE_API_URL"];

if (typeof BASE_URL !== "string") {
  throw new Error("expected VITE_API_URL");
}

export const getBaseUrl = (): string => BASE_URL;
